import { useSelector } from "react-redux";
import {
  IconBookmark,
  IconCurrencyDollar,
  IconHeart,
  IconHelp,
  IconHomeHand,
  IconLogout,
  IconSettings,
  IconUserCircle,
} from "@tabler/icons-react";
import useAuth from "../../../../hooks/useAuth";
import { AppStore } from "../../../../redux/store";
import { DropdownContainer, DropdownItem, DropdownDivider } from "./DropdownItem";

const DropdownMenu = () => {
  const { country } = useSelector((store: AppStore) => store.country);
  const { handleLogout } = useAuth();

  return (
    <DropdownContainer>
      <DropdownItem icon={<IconUserCircle size={22} />} href={`/app/${country}/l/opciones/mi-cuenta`}>
        Perfil
      </DropdownItem>
      <DropdownItem icon={<IconHeart size={22} />} href={`/${country}/favoritos`}>
        Lista de favoritos
      </DropdownItem>
      <DropdownItem icon={<IconBookmark size={22} />} href={`/${country}/busquedas-guardadas`}>
        Búsquedas guardadas
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconSettings size={22} />} href={`/app/${country}/l/opciones/mi-cuenta`}>
        Configuración de la cuenta
      </DropdownItem>
      <DropdownItem icon={<IconHelp size={22} />} href={`/${country}/ayuda`}>
        Centro de ayuda
      </DropdownItem>

      {country === "sv" && (
        <>
          <DropdownDivider />
          <a
            href={`/${country}/venta/vender-casa-apartamento-con-propi`}
            className="flex items-center justify-between px-2 py-1.5 rounded-lg hover:bg-[#F5F5F5] transition-colors"
          >
            <div className="flex-1 pr-3">
              <p className="text-[#212121] text-sm font-semibold leading-snug">Conviértete en propietario</p>
              <p className="text-[#757575] text-xs leading-snug mt-0.5">Alquila o vende tu propiedad fácilmente con Propi</p>
            </div>
            <div className="w-10 h-10 rounded-xl bg-[#E6F9F0] flex items-center justify-center shrink-0">
              <IconHomeHand size={22} className="text-[#00B66B]" />
            </div>
          </a>
        </>
      )}

      <DropdownDivider />

      <DropdownItem icon={<IconCurrencyDollar size={22} />} href={`/${country}/referidos`}>
        Refiere y gana
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconLogout size={22} />} onClick={handleLogout}>
        Cerrar sesión
      </DropdownItem>
    </DropdownContainer>
  );
};

export default DropdownMenu;
